import { FC } from "react";

interface Props {
  filled?: boolean;
}

const CheckboxIcon: FC<Props> = ({ filled }) => {
  if (filled) {
    return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="191A1F"><rect width="15" height="15" x=".5" y=".5" fill="#191A1F" stroke="#191A1F" rx="1.5"/><path fill="#fff" d="m3 8.406 1.111-1.507L7 9.449 11.667 4 13 5.275 7.111 12 3 8.406Z"/></svg>;
  } 
  
  return <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none"><rect width="15" height="15" x=".5" y=".5" stroke="#191A1F" rx="1.5"/></svg>
}

export default CheckboxIcon;